<div class="modal-header">
  <h5 class="modal-title">Duplication du calcul</h5>
</div>
<div class="modal-body">
  <p>Vous vous appretez a dupliquer le calcul. Assurez-vous d'avoir sauvegarder vos modifications !</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-seconday" data-bs-dismiss="modal" type="button">Annuler
  </button>
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Oui je veux dupliquer ce calcul
  </button>
</div>
